import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useNavigation } from '@react-navigation/native';
import React, { useRef } from 'react';
import { Image } from 'react-native';
import styled, { css } from 'styled-components/native';
import DefaultImg from '@/assets/img/default_img.svg';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color.ts';
import { font } from '@/constant/font.ts';
export default function ImageList({ images, roundCorners, isSinglePreview, onPressImage: onPressImageProp, }) {
    const navigation = useNavigation();
    const initialFocusedIndex = useRef(0); // 이미지 상세 들어갈 때 어떤 이미지를 보여줄지
    const hiddenImages = isSinglePreview ? images.slice(1) : images.slice(3);
    function onPressImage(index) {
        initialFocusedIndex.current = index;
        if (onPressImageProp) {
            onPressImageProp(index, images.map(image => image.imageUrl));
            return;
        }
        navigation.navigate('ImageZoomViewer', {
            imageUrls: images.map(image => image.imageUrl),
            index: index,
        });
    }
    return (_jsx(ImageListView, { roundCorners: roundCorners, children: isSinglePreview ? (_jsx(ImageBox, { image: images[0], onPress: () => onPressImage(0), isSinglePreview: true, hiddenImageLength: hiddenImages.length, elementName: "place_detail_image", index: 0 })) : (_jsxs(_Fragment, { children: [_jsx(ImageBox, { image: images[0], onPress: () => onPressImage(0), elementName: "place_detail_image", index: 0 }), _jsx(ImageBox, { image: images[1], onPress: () => onPressImage(1), elementName: "place_detail_image", index: 1 }), _jsx(ImageBox, { image: images[2], hiddenImageLength: hiddenImages.length, onPress: () => onPressImage(2), elementName: "place_detail_image", index: 2 })] })) }));
}
function ImageBox({ image, hiddenImageLength = 0, isSinglePreview, onPress, elementName, index, }) {
    if (!image) {
        return (_jsx(Placeholder, { children: _jsx(DefaultImg, {}) }));
    }
    const url = image.thumbnailUrl || image.imageUrl;
    return (_jsxs(ImageContainer, { elementName: elementName, logParams: { image_index: index.toString(), image_url: url }, onPress: onPress, isSinglePreview: isSinglePreview, children: [_jsx(Image, { resizeMethod: "resize", resizeMode: "cover", source: { uri: url }, style: { width: isSinglePreview ? 101 : '100%', aspectRatio: 1 } }), hiddenImageLength > 0 && (
            // 화면 너비에 담기지 않는 이미지들 처리, + N 표시하기
            _jsx(MoreImage, { children: _jsxs(MoreImageCount, { children: ["+ ", hiddenImageLength] }) }))] }));
}
const ImageListView = styled.View `
  flex-direction: row;
  flex-shrink: 2;
  overflow: hidden;
  gap: 4px;
  ${({ roundCorners }) => roundCorners &&
    css `
      border-radius: 12px;
    `}
`;
const Placeholder = styled.View `
  flex: 0 0 33.333%;
  justify-content: center;
  align-items: center;
  background-color: ${color.gray10};
`;
const ImageContainer = styled(SccPressable) `
  flex: ${({ isSinglePreview }) => (isSinglePreview ? 'none' : '0 0 33.333%')};
  position: ${({ isSinglePreview }) => (isSinglePreview ? 'static' : 'relative')};
`;
const MoreImage = styled.View `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  background-color: ${color.blacka70};
  height: 20px;
`;
const MoreImageCount = styled.Text `
  color: ${color.white};
  font-size: 12px;
  line-height: 14px;
  font-family: ${font.pretendardBold};
`;
